const getParameterByName = (name, url) => {
  const definedFontStrings = url.replace('https://fonts.googleapis.com/css2?', '')
    .split('&').filter((item) => item.includes(name));

  const fontNames = definedFontStrings.map((item) => {
    const regex = new RegExp(`${name}(=([^&#:]*))`);
    const results = regex.exec(item);

    return decodeURIComponent(`'${results[2].replace(/\+/g, ' ')}'`);
  });

  return fontNames;
};

const getFontWeightParameters = (name, url) => {
  const selectedFontName = name.replace(/\s/g, '+');

  const definedFontString = url.replace('https://fonts.googleapis.com/css2?', '')
    .split('&').find((item) => item.includes(selectedFontName.substring(1, selectedFontName.length - 1)));

  const fontData = definedFontString.split('wght@');
  return fontData[1]?.length
    ? fontData[1].split(';')
    : [300, 400, 500, 600, 700, 800];
};

const textTransformValues = ['none', 'capitalize', 'uppercase'];

const textAlignValues = ['left', 'center', 'right'];

const lineHeightValues = ['1', '1.1', '1.2', '1.3', '1.4', '1.5', '1.6', '1.7', '1.8'];

const listStyleTypes = ['none', 'disc', 'circle', 'square'];

const textDecorationValues = ['none', 'underline'];

const buttonFontSizeValues = ['12', '13', '14', '15', '16', '17', '18'];

const fontStyleValues = ['normal', 'italic', 'oblique'];

export {
  getParameterByName,
  getFontWeightParameters,
  textTransformValues,
  textAlignValues,
  lineHeightValues,
  listStyleTypes,
  textDecorationValues,
  buttonFontSizeValues,
  fontStyleValues
};
